<template>
    <div class="inviter-container-1">
        <inner-children-renderer v-if="_child" :children="_child" />
    </div>
</template>

<script>
import Vue from 'vue';

const {
    plugins: { ComplexComp },
    store: { variable }
} = require('@futuweb/fego-render');

import ChildItem from '../children/item/render/index.vue';
import { CHILD, HAS_INVITER, NO_INVITER, LOGINED_MODE } from '../constant';
import { query2obj } from './utils.js';

const {
    common: {
        request: { bindCommonApi }
    }
} = require('@futuweb/fego-render');

const commonApiRequest = bindCommonApi('inviter-container');

export default Vue.extend({
    name: 'inviter-container-1',

    mixins: [
        ComplexComp.Inner.Parent.Mixins({
            [CHILD]: ChildItem
        })
    ],

    props: ['tpl'],

    data() {
        return {
            inviterStatus: 0,
            loginedMode: this.tpl.props.loginedMode ?? LOGINED_MODE.NO
        };
    },

    computed: {
        _child() {
            return this.tpl.children.find((c) => c.props.status === this.inviterStatus);
        }
    },

    async created() {
        if (variable.data.UID && this.loginedMode === LOGINED_MODE.NO) {
            this.inviterStatus = NO_INVITER;
            return;
        }
        this.inviterStatus = await this.getInviterStatus();
    },
    methods: {
        // 初始化参数
        initParams() {
            const query = query2obj();
            if (!query.global_content) {
                return;
            }
            try {
                const json = JSON.parse(query.global_content);
                if (json.promote_id || json.invite) {
                    return {
                        invite: json.invite,
                        promote_id: json.promote_id,
                        sub_promote_id: json.sub_promote_id || 1
                    };
                }
            } catch (error) {
                console.log(error);
            }
        },

        async getInviterStatus() {
            const global_content = this.initParams();
            if (!global_content) {
                return NO_INVITER;
            }
            const params = {};
            if (global_content.invite) {
                params.invite = global_content.invite;
            }
            if (global_content.promote_id) {
                params.promote_id = global_content.promote_id;
                params.sub_promote_id = global_content.sub_promote_id || 1;
            }
            if (Object.keys(params).length === 0) {
                return NO_INVITER;
            }
            try {
                const inviter = await commonApiRequest.get('inviter', params);
                if (!inviter?.uid) {
                    return NO_INVITER;
                } else {
                    return HAS_INVITER;
                }
            } catch (error) {
                return NO_INVITER;
            }
        }
    }
});
</script>

<style lang="less" scoped>
.inviter-container-1 {
    height: auto !important;
}
</style>
